class Counter {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

const countAll = document.querySelectorAll(".js-count-box")



for (let i = 1; i <= countAll.length; i++) {
  $(`.js-count-box-${i}`).on('inview', function(event, isInView) {

    $(this).addClass("is-active");

    if (isInView) {
      $(`.js-count-box-${i} .count-up`).each(function(){
        if(!$(this).hasClass("inview-counter")){
          $(this).prop('Counter',0).animate({//0からカウントアップ
            Counter: $(this).text()
          }, {
            // スピードやアニメーションの設定
            duration: 1500,//数字が大きいほど変化のスピードが遅くなる。2000=2秒
            easing: 'swing',//動きの種類。他にもlinearなど設定可能
            step: function (now) {
              $(this).text(Math.ceil(now));
            }
          });
          $(this).addClass("inview-counter");
        }
      });
      //要素が見えたときに実行する処理
    }
  });

}


  }
}

